"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
var consts_1 = require("../consts");
var mapFormData = function (form) {
    var mappedFormData = {
        formName: (form === null || form === void 0 ? void 0 : form.formName)
            ? (0, utils_1.removeSpecialCharacters)(form.formName)
            : consts_1.NOT_AVAILABLE,
        formError: (form === null || form === void 0 ? void 0 : form.formError)
            ? (0, utils_1.removeSpecialCharacters)(form.formError)
            : consts_1.NOT_AVAILABLE,
    };
    return mappedFormData;
};
exports.default = mapFormData;
